import React, { useState } from 'react'

import {
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	TextField,
	CircularProgress
} from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'

import { useSelector, useDispatch } from 'react-redux'
import { showError, addAddOnFunds } from '../../../actions/misc/misc.actions'

const useStyles = makeStyles((theme) => ({
	title: {
		marginBottom: 24
	},
	dialogActions: {
		justifyContent: 'flex-start'
	},
	fieldWrapper: {
		minWidth: '400px !important',
		width: '400px !important',
		marginBottom: 20,
		'& .MuiFilledInput-root': {
			minWidth: '400px !important',
			width: '400px !important'
		},
		'& .MuiTextField-root': {
			minWidth: '400px !important',
			width: '400px !important'
		}
	}
}))

const CreditAccountDialog = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const selected = useSelector((state) => state.specific.households.selected)
	const loading = useSelector((state) => state.specific.households.bankLoading)
	let { isShown, setIsShown } = props
	const [amount, setAmount] = useState(0)
	const [amountError, setAmountError] = useState(false)

	const addCredit = () => {
		if (!amount) {
			dispatch(showError('Please fix form errors.'))
		} else {
			let num = onlyNumbers(amount)
			let item = {
				adding,
				type: 'add_on_bank',
				amount: num,
				household_id: selected._id
			}
			dispatch(addAddOnFunds(item)).then(() => {
				closeDialog()
			})
		}
	}

	const closeDialog = () => {
		setAmount('')
		setIsShown(false)
	}

	const onlyNumbers = (value) => {
		if (!value || value === '0') return value
		const onlyNums = value.toString().replace(/[^\d]/g, '').replace(/^0+/, '')
		if (onlyNums.length) return onlyNums
		return 0
	}

	const formatNumsToDollars = (value) => {
		if (value !== undefined && value !== null) {
			return `${(value / 100).toFixed(2)}`
		}
		return ''
	}

	const { adding } = props

	const word = `${adding ? 'ADD' : 'REMOVE'} FUNDS`

	return (
		<Dialog
			open={isShown}
			aria-labelledby="form-dialog-title"
			className={classes.dialog}
			onClose={closeDialog}
			PaperProps={{
				style: {
					minWidth: '448px',
					maxWidth: '448px',
					width: '448px'
				}
			}}>
			<DialogTitle className={classes.title}>
				{adding ? 'Add Funds to Enrichment Bank' : 'Remove Funds From Enrichment Bank'}
			</DialogTitle>
			<DialogContent>
				<div className={classes.fieldWrapper}>
					<TextField
						label="Amount"
						variant="filled"
						value={formatNumsToDollars(onlyNumbers(amount))}
						onChange={(e) => setAmount(e.target.value)}
						error={amountError}
						helperText={amountError ? 'Please add an amount.' : null}
					/>
				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button variant="contained" color="secondary" onClick={addCredit} disabled={loading}>
					{loading ? <CircularProgress /> : word}
				</Button>
				<Button variant="outlined" color="secondary" onClick={closeDialog} disabled={loading}>
					CANCEL
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default CreditAccountDialog
